// src/pages/Moderation/ChannelsViolationsPage/ui/ChannelsQuickStats/ChannelsQuickStats.tsx
import React from 'react';

import { ChannelsCounters, RestrictionAgg } from '../model/types';
import './ChannelsQuickStats.scss';

type Props = {
  totalChannels: number;
  channelsWithRestrictions: number;
  counters: ChannelsCounters | null;
  topRestrictions: RestrictionAgg[];
  onPickRestriction?: (r: number) => void;
};

export const ChannelsQuickStats: React.FC<Props> = ({
  totalChannels,
  channelsWithRestrictions,
  counters,
  topRestrictions,
  onPickRestriction,
}) => {
  const pub = safeNum(counters?.public);
  const priv = safeNum(counters?.private);

  return (
    <section className="cv-stats" role="group" aria-label="Channels quick stats">
      <div className="cv-stats__grid">
        <Card label="Total channels" value={safeNum(totalChannels)} />
        <Card label="With restrictions" value={safeNum(channelsWithRestrictions)} />
        <Card label="Public" value={`${pub}`} />
        <Card
          label="Top restriction"
          value={topRestrictions.length ? `R${safeNum(topRestrictions[0]?.restriction)}` : '—'}
        />
      </div>

      {/* {!!topRestrictions.length && (
        <div className="cv-stats__chips">
          {topRestrictions.slice(0, 8).map((r) => (
            <button
              key={r.restriction}
              className="cv-stats__chip"
              type="button"
              onClick={() => onPickRestriction?.(r.restriction)}
            >
              R{safeNum(r.restriction)} · {safeNum(r.cnt)}
            </button>
          ))}
        </div>
      )} */}
    </section>
  );
};

const Card: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="cv-stats__card">
    <div className="cv-stats__label">{label}</div>
    <div className="cv-stats__value">{value}</div>
  </div>
);

function safeNum(v: unknown, fallback = 0): number {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : fallback;
}
